import {BASEURL, getData, getDatafiles} from "./api";

export const partialNumericRegex = /^[+\-]?(?:\d*(?:\.\d*)?(?:[eE][+\-]?\d*)?)$/;

export const isPartialNumber = (str) => {
  return partialNumericRegex.test(str);
}

export const setAndUpdate = (k, v, setter, update)  =>{
  setter(k, v)
  update(k, v)
}

export const validateAndUpdate = (k, v, setter, update) => {

  if (isPartialNumber(v)) {
    setter(k, v)
    update(k, parseFloat(v))
  }
}

export const downloadImage = (tool, imagePath) => {
  fetch(BASEURL + imagePath)
    .then((response) => response.blob())
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${tool}-plot.jpg`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    })
    .catch((error) => {
      console.error('Error downloading file:', error);
    });
}

export const downloadData = (tool, key_id, ext, loadingSetter) => {
  loadingSetter(true)
  getData(key_id, tool, ext)
    .then(response => {
      const blob = response.data
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');

      const disposition = response.headers['content-disposition'];
      let filename = `${tool}-data.${ext}`;
      if (disposition && disposition.includes('filename=')) {
        const matches = disposition.match(/filename="?([^"]+)"?/);
        if (matches && matches[1]) {
          filename = matches[1];
        }
      }

      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      loadingSetter(false)
    })
    .catch((error) => {
      console.error('Error downloading file:', error);
      loadingSetter(false)
    });

}


export const downloadZippedData = (apiparams, loadingSetter) => {
  loadingSetter(true)
  getDatafiles(apiparams)
    .then(response => {
      const blob = new Blob([response.data], { type: 'application/zip' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      let filename = `mhdwebx_datafiles.zip`;
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      loadingSetter(false);
    })
    .catch(error => {
      loadingSetter(false);
      console.error('Error downloading data:', error);
    });
}